function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#FF5968",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#AC1EC8",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "url(#b)",
  cx: 17.5,
  cy: 17.5,
  r: 17.5
}), React.createElement("g", {
  stroke: "#FFF",
  strokeWidth: 1.8225
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  strokeLinejoin: "round",
  d: "M19.3865 8.2922l-5.8499 5.6381H8v7.2553h5.4527l5.9338 5.7194z"
}), React.createElement("path", {
  d: "M22.3667 21.6914c.6579-1.1765 1.0442-2.5608 1.0442-4.0481 0-1.5117-.397-2.9162-1.0732-4.104M24.7382 10.864c1.2601 1.8947 2.0066 4.2397 2.0066 6.7793 0 2.516-.7335 4.8404-1.9738 6.7256",
  strokeLinecap: "round"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/bling_podcast.580f7961.svg";
export { SvgComponent as ReactComponent };